import { api } from "@/api";

export type BalanceOperation = "add" | "remove";

interface UpdateAgentBalancePayload {
  userIds: number[];
  operation: BalanceOperation;
  amount: number;
}

export async function updateAgentBalance(
  payload: UpdateAgentBalancePayload
): Promise<{ success: boolean }> {
  await Promise.all(
    payload.userIds.map((agentId) =>
      api.client.patch(`/agents-new/${agentId}/balance`, {
        operation: payload.operation,
        amount: payload.amount,
      })
    )
  );
  return { success: true };
}
